export default class AbstractController {
    #domElArray;
    #eventsFunctionsArray;

    // eventsFunctionsArray = [{ events: [array of events], functionForEvents: function for this events }]
    constructor(domElArray, eventsFunctionsArray) {
        this.#domElArray = domElArray;
        this.#eventsFunctionsArray = eventsFunctionsArray;
    }

    startListeners() {
        this.#domElArray.forEach((domEl) => {
            this.#eventsFunctionsArray.forEach((eventsFunctionObject) => {
                eventsFunctionObject.events.forEach((event) => {
                    domEl.addEventListener(event, eventsFunctionObject.functionForEvents);
                });
            });
        });
    }

    stopListeners() {
        this.#domElArray.forEach((domEl) => {
            this.#eventsFunctionsArray.forEach((eventsFunctionObject) => {
                eventsFunctionObject.events.forEach((event) => {
                    domEl.removeEventListener(event, eventsFunctionObject.functionForEvents);
                });
            });
        });
    }
}
